// extracted by mini-css-extract-plugin
export default {"purchaseIcon":"KKL9yb"};